import React, { useState, useEffect } from "react";
import { Box, Grommet, Grid, Sidebar, Card, Select, CardHeader, CardFooter, CardBody, Text, Image, Button, Heading, ResponsiveContext } from 'grommet';
import {
    Task, FormClose
} from "grommet-icons";
import  { Redirect } from 'react-router-dom';
import './css/index.css';
import AccountBox from "./components/Account";
import AttivitaDet1 from "./components/activity/AttivitaDet1";
import Dashboard from "./components//dashboard/Dashboard"
import {useLazyQuery, useMutation, useSubscription} from '@apollo/client';
import {GET_TENANT_DATA, QUERY_GET_CHILDREN_AREA, QUERY_ME} from "./components/apolloClient/loginGQL";
import {deleteCookie, extractRoleFromWhoami, extractRootTreeFromWhoami} from "./utilis/utils";
import {tenant, tenantTypeFirstUpperCase} from "./components/tenant.js";
import {USER_NOTIFICATION} from "./components/notifications/notificationGQL.js";
import {Layer as LayerGrommet} from "grommet/components/Layer/index.js";
import SideBarDesktop from "./components/SideBar/SideBarDesktop.js";
import CardMenu from "./components/Card/CardMenu.js";
import Anagrafiche2 from "./components/registryComponent/Anagrafiche2.js";
import Notifiche from "./components/notifications/Notifiche.js";
import MapLocation from "./components/mapLocation/MapLocation.js";
import UserEventList from "./components/UserEvents/UserEventList.js";
import UserClubMatePayments from "./components/payments/Payments.js";
import SendNotification from "./components/notification/SendNotification.js";
import EntranceList from "./components/entrance/EntranceList.js";

const theme = {
  global: {
    input:{
      font:{
        weight: 0
      }
    },
    colors: {
      brand: '#f8b20e', //#f8b20e
      'accent-1': 'white',
      'focus': '#f8b20e',
      "my-text-color": "",
      background: 'trasparent',
    },
    font: {
      family: '',
      size: '18px',
      height: '20px',

    },
  },
};

const HomePage = () => {

  const [ruoli, setRuoli] = useState({Ruolo:"admin"});
  const [notifications, setNotifications] = useState([]);

  let [newCantiere, setNewCantiere] = useState(null);
  const [cantieri, setCantieri] = useState([]);
  const [areeId,setAreeId]=useState([]);
  const [page,setPage]=React.useState("Home"); //Da cambiare come parametro scheda home
  const [smallSideBar,setSmallSideBar]=React.useState(false);
  const [userLogged,setUserLogged]=React.useState(null);
  const [toDoList,setToDoList]=React.useState([]);
  const [functionPermission,setFunctionPermission]=React.useState({});
  const scrollSidebar=React.useRef(null);
  const [showLayerMachineType,setShowLayerMachineType]=React.useState(false);
  const [ queryGetTenantData
  ]  = useLazyQuery(GET_TENANT_DATA, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
        const tenantData=data["core_tenant"][0];
        if(tenantData){
            setFunctionPermission({...functionPermission,...tenantData})
        }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

  const [ getNotification
  ] = useLazyQuery(USER_NOTIFICATION, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const notifications=data[`clubmate_clubmatenotifications_clubmateusernotification`].map((el)=>el?.clubmatenotifications_clubmatenotification)
      if(notifications){
        setNotifications(notifications);
      }
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    const [ queryMe
  ]  = useLazyQuery(QUERY_ME, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      //extractRoleFromWhoami(data,setRuoli,setCantieri,setNewCantiere,setAreeId,queryGetChildrenArea);
      //setUserLogged({name:data[`${tenant}`]["whoamiClubmate"].profile.name,surname:data[`${tenant}`]["whoami"].profile.surname,email:data[`${tenant}`]["whoami"].username});
      //setFunctionPermission({modifyRegister: data[`${tenant}`]["whoami"].profile.modifyRegistry || false, supersetPermission: data[`${tenant}`]["whoami"].profile.supersetPermission || false, warehousePermission: data[`${tenant}`]["whoami"].profile.warehousePermission || false ,toDoPermission:data[`${tenant}`]["whoami"].profile.toDoPermission || false, modifyUser:data[`${tenant}`]["whoami"].profile.modifyUser || false });
      //sessionStorage.setItem("hideRegistry",data[`${tenant}`]["whoami"].profile.modifyRegistry);
      sessionStorage.setItem("userId",data[`${tenant}`]["whoamiClubmate"].id);
      getNotification({variables:{id:sessionStorage.getItem("userId")}})
      //getToDo({variables:{id:sessionStorage.getItem("userId")}})
     // queryGetTenantData({variables:{name:tenant}});
      },
    onError:(error)=>{
      console.log("error",error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    const [ getToDo
      ] = useLazyQuery(USER_NOTIFICATION, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
          const notifications=data[`${tenant}_users_usernotification`].map((el)=>el.users_notification)
          if(notifications){
            setNotifications(notifications);
          }
        },
        notifyOnNetworkStatusChange: true, // did the work
      });


    React.useEffect(()=>{
        if(cantieri.length>0 && newCantiere===null){
            setNewCantiere(cantieri[0])
        }
    },[cantieri])


  /**
   * Funzione che cambia il cantiere selezionato nel momento in cui viene selezionato nella Select
   * @param {*} option Cantiere selezionato nella Select della SideBar
   */
  function handleCantiere (option) {
    setNewCantiere(option);
    sessionStorage.setItem('Cantiere', option.id);
  }
  
  useEffect(() => {
    if(sessionStorage.getItem('Page')!==undefined && sessionStorage.getItem('Page')!==null){
      setPage(sessionStorage.getItem('Page'))
    }else{  //Primo avvio  
      setPage("Home");
    }
    if(sessionStorage.getItem('clickNotify')!==undefined && sessionStorage.getItem("clickNotify")!==null){
      sessionStorage.removeItem("clickNotify");
      sessionStorage.setItem("tab1",1);
    }
    if(sessionStorage.getItem("smallSidebar")!==null){
      if(sessionStorage.getItem("smallSidebar")==="true"){
        setSmallSideBar(true);
      }else{
        setSmallSideBar(false)
      }
    }
    queryMe();
  }, []);

  React.useEffect(()=>{
      if(scrollSidebar && (page==="ToDo" || page==="Magazzino")){
          scrollToBottom()
      }
  },[page,scrollSidebar])

  const scrollToBottom = () => {
    const myDiv = scrollSidebar?.current;
    if(myDiv){
      myDiv.scrollTop = myDiv?.scrollHeight;
    }
  };

  function trovaCantierePerId(cantieri) {
      const idCantiereDesiderato = parseInt(sessionStorage.getItem("Cantiere"));
      if (!idCantiereDesiderato) {
        return null; // Restituisci null se non c'è un id valido in sessionStorage
      }
      const cantiereTrovato = cantieri.find(cantiere => cantiere.id === idCantiereDesiderato);
      return cantiereTrovato || null; // Restituisci l'oggetto trovato o null se non trovato
  }


  React.useEffect(()=>{
      if(ruoli?.Ruolo !== 'admin'){
           if(sessionStorage.getItem("Cantiere")!==null){
                setNewCantiere(trovaCantierePerId(cantieri));
            }
      }
  },[cantieri])

  /**
   * Ogni volta che viene selezionata una pagina diversa la salvo in session storage.
   * Permette di ritornare all'ultima pagina visitata nel caso in cui venga ricaricata la pagina
   */
  useEffect(() => {
    sessionStorage.setItem('Page',page);
  }, [page]);

  const [width, setWidth]   = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  
    /**
     * Funzione che permette di sapere le dimensioni aggiornate dello schermo
     */
  const updateDimensions = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
  }


  useEffect(() => {
      window.addEventListener("resize", updateDimensions);
      return () => window.removeEventListener("resize", updateDimensions);
  }, []);



  if (!sessionStorage.getItem("accessToken")) {
      return <Redirect to='/' />
  }


  function handleLogOut() {
    sessionStorage.clear();
    localStorage.clear();
    deleteCookie("accessToken");
    deleteCookie("refreshToken");
    window.location.href = window.location.origin + "/";
  }
  

  return (

    <Grommet theme={theme} className="font-link">
            <Box direction="row">
              {
                ruoli!==null &&
                  <SideBarDesktop handleforlogout={handleLogOut} cantieri={cantieri} actualPage={page} setShowLayerMachineType={setShowLayerMachineType} scrollSidebar={scrollSidebar} handleCantiere={handleCantiere} newCantiere={newCantiere} ruoli={ruoli} setRuoli={setRuoli} smallSideBar={smallSideBar} setSmallSideBar={setSmallSideBar} page={page} showLayerMachineType={showLayerMachineType} functionPermission={functionPermission} toDoList={toDoList} notifications={notifications} setPage={setPage}
                  />
              }
                <Box width="100%" className="menu" >
                 {
                      showLayerMachineType && ruoli?.Ruolo==="Meccanico" && (
                        <LayerGrommet  full={window.screen.width<1100} onEsc={()=>setShowLayerMachineType(false)} onClickOutside={()=>setShowLayerMachineType(false)}>
                        <Box height="100%" round="medium" pad="15px" background="#f8b20e">
                          <Button  alignSelf="end" icon={<FormClose color="grey" size="35px" onClick={()=>setShowLayerMachineType(false)}/>}></Button>
                        </Box>
                      </LayerGrommet>
                      )
                    }
                  {page==="Anagrafiche" && <Anagrafiche2 aree={areeId} ruoli={ruoli} modifyRegistry={functionPermission?.modifyRegister} modifyUser={functionPermission?.modifyUser}/>}

                  {page==="Attività" && <AttivitaDet1 aree={areeId}/>}

                  {page==="Analitiche" && <Dashboard aree={areeId} exportCsvExternalCode={functionPermission?.export_csv_external_code} cantieri={cantieri} permissionSuperset={functionPermission?.supersetPermission}/>}

                  {page==="Notifiche" && <Notifiche aree={areeId} notifications={notifications} getNotification={getNotification} />}

                  {page==="Mappa" && <MapLocation/>}

                  {page==="ServiziUtilizzati" && <UserEventList/>}

                  {page==="Movimenti" && <UserClubMatePayments/>}

                  {page==="SendNotification" && <SendNotification/>}

                  {page==="Entrance" && <EntranceList/>}

                  {
                    page==="Home" &&
                         <Box direction="column" background="transparent"  height="100%" overflow="auto">
                          {userLogged && <AccountBox logout={handleLogOut} userLogged={userLogged}/>}

                          <CardMenu ruoli={ruoli} setPage={setPage} functionPermission={functionPermission}/>

                        </Box>
                  }
               </Box>
            </Box>
    </Grommet>
  );
}
export default HomePage;